import AdjudicationsListComponent from "src/components/Adjudications/AdjudicationsList"

const CompletedAdjudications = () => {
  return (
    <AdjudicationsListComponent status='completed' label='Completed' />
  )
}

export default CompletedAdjudications